import axios from "axios";

axios.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      // Handle network errors globally
      console.error("Network error:", error);
      alert("Cannot reach the server. Please try again later.");
    }
    return Promise.reject(error);
  }
);
